import { yupResolver } from '@hookform/resolvers/yup';
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Grid,
  IconButton,
  withStyles,
  DialogTitle,
} from '@material-ui/core';
import { CloseOutlined } from '@material-ui/icons';
import { PropTypes } from 'prop-types';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const CustomDialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <DialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseOutlined />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
});

const UserGroupPlatformDialog = (props) => {
  const handleClickClose = () => {
    props.handleClose();
  };

  return (
    <Box>
      <Dialog
        id="user-group-platform-dialog"
        open={props.open}
        onClose={handleClickClose}
        aria-labelledby="popup-user-group-dialog-platform-title"
        aria-describedby="popup-user-group-dialog-platform-description"
        maxWidth="md"
        fullWidth
      >
        <CustomDialogTitle id="popup-user-group-dialog-platform-title" onClose={handleClickClose}>
          Group: {props.row?.key}
        </CustomDialogTitle>
        <DialogContent id="popup-user-group-dialog-platform-description" dividers>
          {props.row ? (
            <Grid container spacing={2}>
              {props.row?.platforms?.map((platform) => (
                <Grid item xs={6} key={platform.platform_code}>
                  <Typography variant="body1">
                    {platform.platform_name} ({platform.platform_code})
                  </Typography>
                  <Typography variant="caption">{platform.merchant_code}</Typography>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Typography>Not Found</Typography>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

UserGroupPlatformDialog.propTypes = {
  row: PropTypes.object,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default UserGroupPlatformDialog;
